import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';
import _ from 'lodash';

import { E勘定科目カテゴリ } from '@/openapi/enum';
import { 取込勘定科目Request } from '@/openapi/user';

import C勘定科目大分類Select from '@/components/勘定科目/大分類Select/勘定科目大分類Select.vue';
import C勘定科目中分類Select from '@/components/勘定科目/中分類Select/勘定科目中分類Select.vue';

import 取込Mixin from '@/entries/user/mixins/取込Mixin';

export default mixins(取込Mixin).extend({
  name: 'C取込勘定科目追加Dialog',

  components: {
    C勘定科目大分類Select,
    C勘定科目中分類Select,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    e勘定科目カテゴリ: {
      type: Number as PropType<E勘定科目カテゴリ>,
      required: true,
    },
    取込勘定科目: {
      type: Object as PropType<取込勘定科目Request>,
    },
  },

  data(): {
    hasError: boolean;
    new勘定科目: 取込勘定科目Request;
  } {
    return {
      hasError: false,
      new勘定科目: {
        c大分類: '',
        c勘定科目: '',
      },
    };
  },

  watch: {
    visible(): void {
      if (!this.visible) return;

      this.new勘定科目 = _.cloneDeep(this.取込勘定科目);
    },
  },

  methods: {
    add勘定科目(): void {
      // 勘定科目が未入力の場合はエラー表示
      this.hasError = this.new勘定科目.c勘定科目.length === 0;
      if (this.hasError) return;

      this.$emit('add', this.new勘定科目);
    },
  },
});
